import { render, staticRenderFns } from "./PDFViewerActions.vue?vue&type=template&id=0b230620"
import script from "./PDFViewerActions.vue?vue&type=script&lang=js"
export * from "./PDFViewerActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports